import { getData } from '../../apis/api.helpers'
import apiUrl from '../../apis/api.url'
import { useMutation } from '@tanstack/react-query'

const fetchVerifyEmail = async (id: string) => {
  const url = `${apiUrl.VERIFY_EMAIL}/${id}`
  const response = await getData(url)
  return response
}

export const useVerifyEmail = () => {
  return useMutation({
    mutationFn: (id: string) => fetchVerifyEmail(id),
  })
}
